import { getItem, removeItem } from './localStorageUtil';
import { LOCAL_STORAGE_KEYS } from '../const/localStorageConst';
const PORTAL_API = '/fg-ai-center/fxzapi';
const LOGIN_URL = '/fuxiaozhu/login';
const EXPIRED_NOTICE_KEY = 'portal_session_expired';
let loggingOut = false;
export const isPortalLogoutInProgress = () => loggingOut;

export function clearPortalSession() {
  removeItem(LOCAL_STORAGE_KEYS.TOKEN);
  removeItem(LOCAL_STORAGE_KEYS.IS_ADMIN);
  removeItem(LOCAL_STORAGE_KEYS.USER_INFO);
  removeItem(LOCAL_STORAGE_KEYS.FORCE_UPDATE_PASSWORD);
  try { window.sessionStorage.removeItem(LOCAL_STORAGE_KEYS.TOKEN); } catch { /* storage unavailable */ }
  window.dispatchEvent(new Event('portal-session-cleared'));
}

export function expirePortalSession() {
  if (loggingOut || (!getItem(LOCAL_STORAGE_KEYS.TOKEN) && !window.sessionStorage?.getItem(LOCAL_STORAGE_KEYS.TOKEN))) return;
  clearPortalSession();
  try { window.sessionStorage.setItem(EXPIRED_NOTICE_KEY, '1'); } catch { /* storage unavailable */ }
  if (window.location.pathname !== LOGIN_URL) window.location.replace(LOGIN_URL);
}

export function consumeExpiredNotice() {
  try {
    const expired = window.sessionStorage.getItem(EXPIRED_NOTICE_KEY);
    window.sessionStorage.removeItem(EXPIRED_NOTICE_KEY);
    return expired === '1';
  } catch { return false; }
}

// The OIDC bridge must run while the portal token is still valid. Logout is best-effort,
// but local credentials are always removed even when either network request fails.
export async function logoutPortalSession() {
  loggingOut = true;
  const token = getItem(LOCAL_STORAGE_KEYS.TOKEN);
  try {
    await fetch('/fg-ai-center/oidc/session/logout', {
      method: 'POST', credentials: 'same-origin', signal: AbortSignal.timeout(5000),
      headers: token ? { token: String(token) } : {},
    });
  } catch { /* The bridge may be unavailable. Still revoke the portal token. */ }
  try {
    if (token) {
      await fetch(`${PORTAL_API}/user/logout`, {
        method: 'POST', credentials: 'same-origin', signal: AbortSignal.timeout(5000),
        headers: { 'Content-Type': 'application/json', token: String(token) },
        body: '{}',
      });
    }
  } catch { /* Local logout must not depend on network availability. */ }
  clearPortalSession();
  loggingOut = false;
}

async function portalPost(path) {
  const token = getItem(LOCAL_STORAGE_KEYS.TOKEN);
  if (!token || loggingOut) return { status: 403 };
  try {
    const response = await fetch(`${PORTAL_API}${path}`, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', token: String(token) },
      body: '{}',
    });
    const data = await response.json();
    if (response.status === 403 || data?.status === 403) {
      if (!loggingOut && getItem(LOCAL_STORAGE_KEYS.TOKEN) === token) expirePortalSession();
      return { status: 403 };
    }
    return data;
  } catch {
    return { status: 0, msg: '网络请求失败' };
  }
}

export const validatePortalSession = () => portalPost('/user/get_user_info');
export const heartbeatPortalSession = () => portalPost('/user/portal_heartbeat');
